<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <rect class="cls-1" x="0" y="0" width="90.07" height="90.07"/>
  <g>
    <path class="cls-3" d="M45.04,79.83h0c-.79,0-1.55-.34-2.08-.92l-20.09-22.21c-.2-.23-.32-.52-.32-.82V12.81c0-3.92,3.19-7.11,7.11-7.11h30.73c3.92,0,7.11,3.19,7.11,7.11V55.87c0,.3-.11,.6-.32,.82l-20.08,22.21c-.53,.59-1.29,.92-2.08,.92Zm-20.03-24.43l19.77,21.86c.09,.09,.19,.11,.26,.11s.17-.02,.26-.12l19.76-21.86V12.81c0-2.57-2.09-4.66-4.66-4.66H29.67c-2.57,0-4.66,2.09-4.66,4.66V55.4Zm41.28,.47h0Z"/>
    <path class="cls-3" d="M45.04,70.11c-2.58,0-4.67-2.1-4.67-4.68s2.1-4.67,4.67-4.67,4.67,2.1,4.67,4.67-2.1,4.68-4.67,4.68Zm0-6.9c-1.23,0-2.22,1-2.22,2.22s1,2.22,2.22,2.22,2.22-1,2.22-2.22-1-2.22-2.22-2.22Z"/>
    <path class="cls-2" d="M42.23,42.66c-3.04-.33-6.01-1.43-7.47-3.44l4.32-5.35c1.17,1.5,3.52,2.67,5.82,2.67,1.39,0,2.23-.4,2.23-1.32,0-.77-.59-1.14-1.94-1.39l-2.78-.55c-4.4-.88-6.81-3.3-6.81-6.92s2.56-6.74,6.63-7.91v-4.95h5.46v4.47c3.33,.33,6.23,1.65,7.62,3.59l-4.76,4.83c-.95-1.32-2.75-2.27-4.65-2.27-1.36,0-2.31,.48-2.31,1.39,0,.7,.51,1.06,1.98,1.36l2.75,.55c4.4,.88,6.81,3.33,6.81,6.96,0,3.99-2.89,7.07-7.44,8.06v4.76h-5.46v-4.54Z"/>
    <polyline class="cls-4" points="37.43 78.89 37.43 84.37 52.64 84.37 52.64 78.89"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "PriceDownloadIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #59c5c7;
  }
  .cls-4 {
    fill: none;
    stroke: #0f5b71;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 3px;
  }
</style>